import { render, staticRenderFns } from "./AccountMetadataForm.vue?vue&type=template&id=4a0b2113&"
import script from "./AccountMetadataForm.vue?vue&type=script&lang=ts&"
export * from "./AccountMetadataForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports